/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS203: Remove `|| {}` from converted for-own loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
    I contain a high-level wrapper for "driving" the application with code, but
    using nomenclature that a human would use to describe the operations.
*/
import application from "application";
import services from "lib/Services";
import Dispatcher from "Dispatcher";
import DevelopmentActions from "data/dev/DevelopmentActions";
import UserActions from "data/UserActions";
import promisify from "lib/promisify";
import appDriver from "lib/AppDriver";
import utils from "it/lib/utils";
import wait from "it/lib/wait";
import ITState from "it/lib/ITState";
import Interpreter from "it/lib/Interpreter";
import RunnerUi from "./RunnerUi";
import {
    clearCookie,
    setCookie,
} from "lib/reauth/utils";
import HybridConfig from "lib/HybridConfig";

if (process.env.NODE_ENV !== "production") {
    // so it can receive the selection action (before app bootstrap)
    // eslint-disable-next-line no-unused-expressions
    require("data/dev/ITTestStore").default;
}

class Iterator {

    constructor(elements) {
        this.size = this.size.bind(this);
        this.hasNext = this.hasNext.bind(this);
        this.next = this.next.bind(this);
        this.elements = elements;
        this.i = -1;
    }

    size() {
        return this.elements.length;
    }

    hasNext() {
        return this.i < (this.elements.length - 1);
    }

    next() {
        if (!this.hasNext()) {
            throw new Error("This iterator is out of elements");
        }
        return new ITDriver(this.elements[++this.i], this.elements.selector);
    }
}

const rootContext = "html";
const selectors = {};
const addSelector = function(name, selector, factory) {
    if (!selectors.hasOwnProperty(name)) {
        selectors[name] = {};
    }
    return selectors[name][selector] = factory;
};

const buildSelectors = (block, ctx) =>
    (() => {
        const result = [];
        for (const n of Object.keys(block || {})) {
            const nb = block[n];
            result.push((function (n, nb) {
                if (n !== "selector") {
                    // it's a subcontext
                    let nc;
                    if (nb instanceof Function) {
                        nc = ctx + " " + n;
                        addSelector(n, nc, nb);
                    } else {
                        if ((nb.selector == null)) {
                            throw new Error(`malformed AppDriver elements definitions: no selector key for "${ctx} ${n}"`);
                        }
                        nc = ctx + " " + nb.selector;
                        addSelector(n, nc);
                    }
                    return buildSelectors(nb, nc);
                }
            })(n, nb));
        }
        return result;
    })()
;

buildSelectors(appDriver.elements, rootContext);

const cleanSemanticSelector = s => s.replace(new RegExp(" +([^ ]|$)", "g"), (m, g1) => g1.toUpperCase());

const cleanCssSelector = s => s.replace(new RegExp(" +", "g"), " ");

const uncleanSemanticSelector = s => s.replace(new RegExp("([A-Z]+)", "g"), (m, g1) => ` ${g1.toLowerCase()}`);

let instanceCounter = 0;
class ITDriver {

    constructor(start = rootContext, selector) {
        this.with = this.with.bind(this);
        this.pop = this.pop.bind(this);
        this.drawTargets = this.drawTargets.bind(this);
        this.size = this.size.bind(this);
        this.iterator = this.iterator.bind(this);
        this.id = instanceCounter++;
        this.chain = [{
            element: (this.element = $(start)),
            selector: (this.selector = cleanCssSelector(selector != null ? selector : this.element.selector))
        }
        ];
    }

    with() {
        const args = Array.prototype.slice.call(arguments);
        let work = args.pop();
        if (!(work instanceof Function)) {
            args.push(work);
            work = null;
        }
        let unwind = 0;
        const atElement = $(this.element.selector);
        for (let selector of args) {
            let domSel, newEl, newSel;
            unwind += 1;
            if (typeof selector === "number") {
                const idxEl = atElement.eq(selector - 1);
                if (idxEl.length === 0) {
                    throw new Error(`Element ${selector} of '${this.element.selector}' doesn't exit.`);
                }
                const id = idxEl.attr("id");
                if ((id == null)) {
                    throw new Error(`Element ${selector} of '${this.element.selector}' doesn't have an id attribute, and thus can't be indexed.`);
                }
                newEl = $(atElement.selector.trim() + "#" + id);
                if (newEl.length !== 1) {
                    throw new Error(`Element ${selector} of '${this.element.selector}' has an id of '${id}', which is ... not unique?!`);
                }
                newSel = this.selector;
            } else { // semantic selector
                selector = $.trim(selector);
                const [sel, ...factoryArgs] = Array.from(selector.split(":"));
                factoryArgs.unshift(atElement);
                const semSel = cleanSemanticSelector(sel);
                if (!selectors.hasOwnProperty(semSel)) {
                    throw new Error(`No "${selector}" (${semSel}) element is known.`);
                }
                const paths = Object.keys(selectors[semSel])
                    .filter(p => p.indexOf(this.selector) === 0)
                    .map(p => ({
                        p,
                        f: selectors[semSel][p],
                    }));
                const pathUniquer = {};
                const existingPaths = [];
                for (const path of paths) {
                    domSel = (() => {
                        if (path.f != null) {
                        if (path.f.length !== factoryArgs.length) {
                            throw new Error(`Incorrect number of arguments to the "${sel}" dynamic selector`);
                        }
                        const block = path.f.apply(null, factoryArgs);
                        buildSelectors(block, this.selector + " " + block.selector);
                        return block.selector;
                    } else {
                        return path.p.substr(this.selector.length);
                    }
                    })();
                    pathUniquer[domSel] = true;
                }
                for (domSel of Object.keys(pathUniquer || {})) {
                    const el = $(domSel, atElement);
                    if (el.length) {
                        let exists = false;
                        for (const ep of existingPaths) {
                            if (ep.length !== el.length) {
                                continue;
                            }
                            exists = true;
                            for (let i = 0; i < ep.length; i++) {
                                const e = ep[i];
                                if (e !== el[i]) {
                                    exists = false;
                                    break;
                                }
                            }
                        }
                        if (exists) {
                            console.warn(`Selector "${selector}" (${semSel}) within (${this.selector}) has multiple paths of resolution, though they currently all resolve the same. It's not a bug, but may introduce flakiness if AppDriver changes in seemingly unrelated ways.`);
                        } else {
                            existingPaths.push(el);
                        }
                    }
                }
                if (existingPaths.length === 0) {
                    throw new Error(`No "${selector}" (${semSel}) element is known in this context (${this.selector}).  Either it doesn't exist here or a developer needs to add support for it in AppDriver.`);
                } else if (existingPaths.length > 1) {
                    throw new Error(`Multiple "${selector}" (${semSel}) elements are known in this context (${this.selector}).  The test need to be more specific.`);
                }

                newEl = existingPaths[0];
                newSel = cleanCssSelector(newEl.selector);
            }
            if (newEl.length === 0) {
                throw new Error(`no "${selector}" (${domSel}) element found in this context (${this.selector}).  A developer probably changed the DOM and didn't update AppDriver`);
            }
            this.chain.push({
                element: (this.element = newEl),
                selector: (this.selector = newSel)
            });
        }
        if (work != null) {
            work();
            while (unwind > 0) {
                unwind -= 1;
                this.pop();
            }
        }
         // to avoid leaking a return value
    }

    pop() {
        this.chain.pop();
        if (this.chain.length === 0) {
            this.element = null;
            this.selector = null;
        } else {
            const last = this.chain[this.chain.length - 1];
            this.element = last.element;
            this.selector = last.selector;
        }
         // to avoid leaking a return value
    }

    drawTargets() {
        this.clearTargets();
        const targets = [];
        for (const n of Object.keys(selectors || {})) {
            const ss = selectors[n];
            for (const p of Object.keys(ss || {})) {
                const f = ss[p];
                if ((p.indexOf(this.selector) === 0) && (f == null)) {
                    targets.push({selector: p, label: uncleanSemanticSelector(n)});
                }
            }
        }
        for (const t of targets) {
            $(t.selector).addClass("IT-target").attr("title", t.label);
        }
    }

    clearTargets() {
        $(".IT-target").removeClass("IT-target").removeAttr("title");
        $("#IT-target-labels").remove();
    }

    size() {
        return $(this.element.selector).length;
    }

    iterator() {
        return new Iterator($(this.element.selector));
    }
}

const addAction = function(action, fn, type) {
    if (ITDriver.prototype[action] != null) {
        const msg = `There are multiple "${action}" helpers defined in AppDriver.`;
        utils.error(msg);
        throw new Error(msg);
    }
    return ITDriver.prototype[action] = function() {
        let result = null;
        const args = Array.prototype.slice.call(arguments);
        const interfaceArgCount = fn.length - 1;
        const atElement = $(this.element.selector);
        if (args.length > interfaceArgCount) {
            const pathArgCount = args.length - interfaceArgCount;
            const workArgs = args.slice(0, pathArgCount);
            const actionArgs = args.slice(pathArgCount);
            workArgs.push(() => {
                actionArgs.unshift(atElement);
                return result = fn.apply(this, actionArgs);
            });
            this.with.apply(this, workArgs);
        } else {
            args.unshift(atElement);
            result = fn.apply(this, args);
        }
        if (type === "inspection") {
            return result;
        }
    };
};

for (const action in appDriver.actions) {
    addAction(action, appDriver.actions[action], "action");
}

for (const insp in appDriver.inspections) {
    addAction(insp, appDriver.inspections[insp], "inspection");
}

export default {
    initialize(params) {
        let delay, script;
        utils.setUpDOM();
        let interpreter = null;
        const spec = $.trim(params.IT != null ? params.IT : "");
        const mSpec = $.trim(params.ITmanifest != null ? params.ITmanifest : "");
        const state = new ITState({
            spec,
            manifestSpec: mSpec,
            autoPlay: params.ITautoPlay !== "false",
            tickDelay: (params.ITtickDelay != null) && !isNaN(delay = parseInt(
                params.ITtickDelay)) ? delay : 50,
        });
        let badThingCount = 0;
        const badThingsMan = function(message) {
            if (++badThingCount >= 5) {
                if (badThingCount === 5) {
                    console.warn("Things went really bad. Like REALLY bad...");
                }
                return;
            }
            if (interpreter != null) { interpreter.pause(); }
            state.set({
                scriptState: "error",
                chromeType: "danger"
            });
            utils.addErrorData(message);
            utils.error(message);
            return utils.complete(false);
        };
        window.addEventListener("error", event =>
            // eslint-disable-next-line no-settimeout
            setTimeout(() => badThingsMan(event.message)));
        window.addEventListener("unhandledrejection", event =>
            // eslint-disable-next-line no-settimeout
            setTimeout(() => badThingsMan(`Uncaught (in promise) ${event.reason}`)));

        const requests = [];
        if (spec === "") {
            // no script
            state.set("autoInitialize", false);
            state.set("autoPlay", false);
            state.set("scriptState", "edit");
            script = "// enter (or paste) your scenario here\n// mockset [name]\nclick search / form / new button\nwait";
            state.set("script", script);
            Dispatcher.dispatch({
                type: DevelopmentActions.AD_HOC_IT_TEST,
                script,
            });
        } else if (spec.indexOf("\n") < 0) {
            // script url
            requests.push(promisify($.ajax({
                url: spec,
                data: { _: Date.now()
            },
                dataType: "text"
            })).then(
                function(data) {
                    state.set("script", data);
                    return Dispatcher.dispatch({
                        type: DevelopmentActions.SELECT_IT_TEST,
                        path: spec,
                        script: data,
                    });
                }
                , function(xhr) {
                    state.set("autoInitialize", false);
                    return state.set("script", `// Failed to load "${spec}"\n// ${xhr.status} ${xhr.statusText}\nfail "loading error"\n`);
            }));
        } else {
            // literal script
            state.set("script", spec);
            Dispatcher.dispatch({
                type: DevelopmentActions.AD_HOC_IT_TEST,
                script: spec,
            });
        }

        if (mSpec !== "") {
            if (mSpec.indexOf("\n") < 0) {
                // manifest url
                requests.push($.ajax({
                    url: mSpec,
                    dataType: "text"
                }).then(
                    // eslint-disable-next-line no-restricted-globals
                    data => self.set("manifest", data)));
            } else {
                // literal manifest
                this.set("manifest", mSpec);
            }
        }

        return application.addInitializationPromise(Promise.all(requests).then( () =>
            new Promise(function(resolve) {
                interpreter = new Interpreter(appDriver, state.get("script"), {tickDelay: state.get("tickDelay")});
                state.set("interpreter", interpreter);
                const ui = new RunnerUi({model: state});
                const driver = new ITDriver();
                const resetTargets = function(v = state.get("showTargets")) {
                    if (v) {
                        return driver.drawTargets();
                    } else {
                        return driver.clearTargets();
                    }
                };

                state.on("change:showTargets", (m, v) => resetTargets(v));

                utils.itview(ui);
                interpreter
                    .on("validated", function(errors) {
                        if (errors.length) {
                            utils.addErrorData(errors[0]);
                            state.set({
                                scriptState: "error",
                                chromeType: "danger"
                            });
                            return utils.complete(false);
                        }
                    })
                    .on("start", function(promise) {
                        state.set({scriptState: "start"});
                        return promise.done( function() {
                            state.set({
                                scriptState: "success",
                                chromeType: "success"
                            });
                            return utils.complete(true);
                        })
                        .fail( function(e) {
                            utils.addErrorData(e);
                            state.set({
                                scriptState: "error",
                                chromeType: "danger"
                            });
                            return utils.complete(false);
                        });
                    })
                    .on("play", () => state.set({scriptState: "play"}))
                    .on("pause", () => state.set({scriptState: "pause"}))
                    .on("close", () => ui.close())
                    .on("all", function(n) {
                        if ((n === "with:start") || (n.substr(n.length - 5) === ":done")) {
                            return resetTargets();
                        }
                    });
                if (state.get("autoInitialize")) {
                    interpreter.validate();
                    if (interpreter.errors.length) {
                        state.set("autoInitialize", false);
                    } else {
                        const mockset = interpreter.getMockset();
                        if (mockset != null) {
                            if (services.__mocked) {
                                throw new Error("Mocking is already configured, so this IT can't set up what it needs.");
                            }
                            window.HybridConfig.mockRoot = `mocks/${mockset}/`;
                            require("mock/lib/mock_config");
                        }

                        const user = interpreter.getUser();
                        if (user != null) {
                            setCookie(user);
                        } else {
                            clearCookie();
                        }

                        const config = interpreter.getConfig() || {};
                        for (const key of Object.keys(config)) {
                            HybridConfig.set(key, config[key]);
                        }
                        const prefs = interpreter.getPreferences() || {};
                        if (Object.keys(prefs).length > 0) {
                            const token = Dispatcher.register(action => {
                                if (action.type !== UserActions.LOADED) { return; }
                                // eslint-disable-next-line no-settimeout
                                setTimeout(() => (() => {
                                        const result = [];
                                        for (const key of Object.keys(prefs)) {
                                            const parts = key.split(".");
                                            result.push(Dispatcher.dispatch({
                                                type: UserActions.UPDATE_LICENSE_PREFERENCE,
                                                impl: parts[0],
                                                pref: parts[1],
                                                value: prefs[key],
                                            }));
                                        }
                                        return result;
                                    })()
                                , 0);
                                return Dispatcher.unregister(token);
                            });
                        }
                    }
                }

                if (state.get("autoInitialize")) {
                    application.on("start", () =>
                        application.layout.on("render", function() {
                            utils.itview(ui);
                            return wait.sync({ for: 60000 }, function() {
                                interpreter.start(driver);
                                if (state.get("autoPlay") && !interpreter.errors.length) {
                                    return interpreter.play();
                                }
                            });
                        })
                    );
                    return resolve();
                }
                // if autoInitialize is false, leave the promise unresolved
            })
        ));
    }
};



// WEBPACK FOOTER //
// ./test/it/lib/ITDriver.js